import React from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function DoctorClinicDetails({ formik }) {
  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
  `;

  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Clinical Details
            </h5>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Primary Role<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Primary Role"
              value={formik.values.primaryRole}
              name="primaryRole"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.primaryRole && formik.errors.primaryRole && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.primaryRole}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Shift Availability
            </label>
            <select
              class="form-control"
              aria-hidden="true"
              value={formik.values.Gender}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name="shiftAvailability"
            >
              <option value="">Select Shift</option>
              <option value="general">General Shift (9 AM - 5 PM)</option>
              <option value="afternoon">Afternoon Shift (1 PM - 9 PM)</option>
              <option value="night">Night Shift (9 PM - 5 AM)</option>
              <option value="on_call">On-Call Duty</option>
            </select>
            {formik.touched.shiftAvailability &&
              formik.errors.shiftAvailability && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.shiftAvailability}
                </div>
              )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Consultation Days
            </label>
            <div>
              <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                className="form-control"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, personName, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </div>
            {formik.touched.languages && formik.errors.languages && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.languages}
              </div>
            )}
          </div>
        </div>

      </div>
    </>
  );
}

export default DoctorClinicDetails;
